import { api } from "@/lib/api";

let ctx = null;
// Create/resume the audio context early (inside the tap that opened the scanner) so the beep isn't blocked later.
export function primeBeep() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch { ctx = null; }
}

export function beep() {
  try {
    // "playback" lets the beep sound even with the iPhone silent switch on (Safari 16.4+).
    if (navigator.audioSession) navigator.audioSession.type = "playback";
    primeBeep();
    if (!ctx) return;
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(1320, t);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.25, t + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.14);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.15);
    osc.onended = () => { if (navigator.audioSession) navigator.audioSession.type = "auto"; };
  } catch {}
}

// Resolve a scanned code to a product. status: ok | incomplete | missing | error
export async function lookupBarcode(code) {
  try {
    const { data } = await api.get(`/foods/barcode/${code}`);
    return { code, food: data.food, status: data.food?.needs_contribution ? "incomplete" : "ok" };
  } catch (e) {
    return { code, food: null, status: e?.response?.status === 404 ? "missing" : "error" };
  }
}
